import { useMemo } from 'react';
import { getColumnMetrics, getHorizontalRangeToRender, getViewportColumns } from '../utils';
export function useViewportColumns(_ref) {
  var rawColumns = _ref.columns,
      minColumnWidth = _ref.minColumnWidth,
      columnWidths = _ref.columnWidths,
      viewportWidth = _ref.viewportWidth,
      defaultFormatter = _ref.defaultFormatter,
      scrollLeft = _ref.scrollLeft;

  var _useMemo = useMemo(function () {
    return getColumnMetrics({
      columns: rawColumns,
      minColumnWidth: minColumnWidth,
      viewportWidth: viewportWidth,
      columnWidths: columnWidths,
      defaultFormatter: defaultFormatter
    });
  }, [columnWidths, rawColumns, defaultFormatter, minColumnWidth, viewportWidth]),
      columns = _useMemo.columns,
      lastFrozenColumnIndex = _useMemo.lastFrozenColumnIndex,
      totalColumnWidth = _useMemo.totalColumnWidth;

  var _useMemo2 = useMemo(function () {
    return getHorizontalRangeToRender(columns, lastFrozenColumnIndex, viewportWidth, scrollLeft);
  }, [scrollLeft, columns, lastFrozenColumnIndex, viewportWidth]),
      colOverscanStartIdx = _useMemo2[0],
      colOverscanEndIdx = _useMemo2[1];

  var viewportColumns = useMemo(function () {
    return getViewportColumns(columns, colOverscanStartIdx, colOverscanEndIdx);
  }, [colOverscanEndIdx, colOverscanStartIdx, columns]);
  return {
    columns: columns,
    viewportColumns: viewportColumns,
    totalColumnWidth: totalColumnWidth,
    lastFrozenColumnIndex: lastFrozenColumnIndex
  };
}